import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: Interpolation<Theme> = css`
  width: 100%;
  padding: 24px;
`

export const headerWrapper: Interpolation<Theme> = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`

export const title: Interpolation<Theme> = css`
  font-weight: 700;
`

export const tableWrapper: Interpolation<Theme> = (theme) => css`
  .table-row {
    min-height: 70px;
  }

  .table-row .actions {
    box-sizing: border-box;
    display: flex;
    column-gap: 12px;
    row-gap: 4px;
    align-items: end;
    transition: all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut};
    overflow: hidden;
    width: 200px;
    flex-wrap: wrap;
  }

  .table-row:not(:hover) .actions {
    height: 0;
  }
`

export const actions: Interpolation<Theme> = css`
  height: 24px;
`

export const largeActions: Interpolation<Theme> = css`
  height: 40px;
`

export const titleWrapper: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
`

export const toolbarWrapper: Interpolation<Theme> = (theme) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 24px;

  ${theme.breakpoints.down(620)} {
    margin-bottom: 12px;
  }
`

export const search: Interpolation<Theme> = (theme) => css`
  ${theme.breakpoints.down(620)} {
    width: 100%;
  }
`

export const filters: Interpolation<Theme> = (theme) => css`
  ${theme.breakpoints.down(620)} {
    justify-content: right;

    .wrapper {
      width: 100%;

      > div {
        width: 100%;

        > div {
          width: calc(100% - 89px - 12px);
        }
      }
    }
  }
`

export const tabsWrapper: Interpolation<Theme> = css`
  display: flex;
  align-items: center;
  gap: 12px;

  button {
    font-size: inherit;
  }
`

export const platformsWrapper: Interpolation<Theme> = css`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const action: Interpolation<Theme> = css`
  height: 18px;
  padding: 0;
  min-width: 0;

  &.MuiButtonBase-root:hover {
    background: none;
  }
`

export const actionLink: Interpolation<Theme> = css`
  height: 18px;
  display: flex;
  align-items: center;
  text-decoration: none;
`
